module.exports = __webpack_public_path__ + "img/Lectura.3036a7b4.png";